
import { defineComponent, useRouter, useStore } from '@nuxtjs/composition-api'
import { explodeUrl } from '@/assets/link'
import { setupTranslationPrefixer } from '@/assets/util'

export default defineComponent({
  props: {
    theme: { type: String, required: true },
  },
  setup() {
    const { t_ } = setupTranslationPrefixer('event-detail')
    const store = useStore()
    const router = useRouter()

    function backToEventOverview() {
      const query = store.getters['event-overview/urlParameters']
      const path = explodeUrl(store.getters['global/eventOverview']?.url).path
      router.push({ path, query })
    }

    return {
      backToEventOverview,
      t_,
    }
  },
})
